import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/database';
// import firebase from 'firebase/app';
// import 'firebase/auth';
// import 'firebase/firestore';
//import 'firebase/database';
import "firebase/compat/storage";
const config = {
    // apiKey: "AIzaSyCVpZ-s91hc4tBm1KhwnGRjjYYb-BWTK40",
    // authDomain: "freetime-7d1e3.firebaseapp.com",
    // databaseURL: "https://freetime-7d1e3-default-rtdb.firebaseio.com",
    // projectId: "freetime-7d1e3",
    // storageBucket: "freetime-7d1e3.appspot.com",
    // messagingSenderId: "600053777019",
    // appId: "1:600053777019:web:d98edd476b2b6f53bfd8de",
    // measurementId: "G-0GGY9XX82C"

    apiKey: "AIzaSyCFQk4KaasZJ1tevkIJozrgsoR2orWAz8U",
    authDomain: "medleymed-f0c86.firebaseapp.com",
    projectId: "medleymed-f0c86",
    storageBucket: "medleymed-f0c86.appspot.com",
    messagingSenderId: "343139885619",
    appId: "1:343139885619:web:fec33c6bf02788dd833946",
    measurementId: "G-P1FP3EB3TY"
};
firebase.initializeApp(config);
// const database = firebase.database();
const database = firebase.database();

export {
  database
};
